/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalReauthSubmissionListEntryPayer
 */
export interface PalReauthSubmissionListEntryPayer {
    /**
     * 
     * @type {string}
     * @memberof PalReauthSubmissionListEntryPayer
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PalReauthSubmissionListEntryPayer
     */
    insurance_type?: string;
}

/**
 * Check if a given object implements the PalReauthSubmissionListEntryPayer interface.
 */
export function instanceOfPalReauthSubmissionListEntryPayer(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PalReauthSubmissionListEntryPayerFromJSON(json: any): PalReauthSubmissionListEntryPayer {
    return PalReauthSubmissionListEntryPayerFromJSONTyped(json, false);
}

export function PalReauthSubmissionListEntryPayerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthSubmissionListEntryPayer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'insurance_type': !exists(json, 'insurance_type') ? undefined : json['insurance_type'],
    };
}

export function PalReauthSubmissionListEntryPayerToJSON(value?: PalReauthSubmissionListEntryPayer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'insurance_type': value.insurance_type,
    };
}

